// src/pages/SafetyTipsPage.jsx
import React from 'react';
import PageHeader from './PageHeader';
import { useLanguage } from '../../context/LanguageContext';
import { FaShieldAlt, FaLock, FaExclamationTriangle } from 'react-icons/fa';

const SafetyTipsPage = () => {
  const { language } = useLanguage();

  const t = {
    English: {
      pageHeaderTitle: "Safety Tips",
      title: "Your Safety is Our Priority",
      subtitle: "Follow these tips to stay safe while finding your perfect match.",
      tips: [
        "Never share personal financial information or send money to anyone.",
        "Verify profiles – look for the verified badge on genuine members.",
        "Meet in public places for the first few meetings.",
        "Inform family/friends about your meetings.",
        "Report any suspicious behavior immediately.",
        "Use our secure chat – don't move to unknown apps quickly."
      ]
    },
    Tamil: {
      pageHeaderTitle: "பாதுகாப்பு குறிப்புகள்",
      title: "உங்கள் பாதுகாப்பே எங்கள் முன்னுரிமை",
      subtitle: "சரியான இணையைக் கண்டறியும் போது பாதுகாப்பாக இருக்க இந்த குறிப்புகளை பின்பற்றுங்கள்.",
      tips: [
        "தனிப்பட்ட நிதி தகவல்களை பகிர வேண்டாம் அல்லது யாருக்கும் பணம் அனுப்ப வேண்டாம்.",
        "சுயவிவரங்களை சரிபார்க்கவும் – உண்மையான உறுப்பினர்களுக்கு சரிபார்க்கப்பட்ட பேட்ஜ் பார்க்கவும்.",
        "முதல் சில சந்திப்புகளுக்கு பொது இடங்களில் சந்தியுங்கள்.",
        "குடும்பம்/நண்பர்களுக்கு உங்கள் சந்திப்புகள் பற்றி தெரிவியுங்கள்.",
        "சந்தேகத்திற்குரிய நடத்தைகளை உடனடியாக புகாரளியுங்கள்.",
        "எங்கள் பாதுகாப்பான அரட்டையை பயன்படுத்துங்கள் – தெரியாத ஆப்களுக்கு விரைவாக செல்ல வேண்டாம்."
      ]
    }
  };

  const txt = t[language];

  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader showBackButton={true} backTo="/" title={txt.pageHeaderTitle} />

      <div className="container mx-auto px-6 py-16">
        <div className="text-center max-w-4xl mx-auto mb-16">
          <img src="https://cdn.le-vpn.com/wp-content/uploads/2017/02/Internet-Best-Practices-For-Dating-Sites.jpg" alt="Online Safety" className="w-full h-96 object-cover rounded-2xl shadow-xl mb-10" />
          <h1 className="text-4xl md:text-5xl font-black text-gray-900 mb-4">{txt.title}</h1>
          <p className="text-xl text-gray-600">{txt.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {txt.tips.map((tip, index) => (
            <div key={index} className="bg-white rounded-2xl p-8 shadow-lg flex items-start gap-6 hover:shadow-xl transition-shadow">
              <FaShieldAlt className="text-4xl text-rose-600 flex-shrink-0" />
              <p className="text-lg text-gray-700 leading-relaxed">{tip}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SafetyTipsPage;